import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[amountValue]',
  exportAs: 'amountValue',
})
export class AmountValueDirective {
  private regex: RegExp = new RegExp(/^(\d+(?:[\.\,]\d{0,1})?)$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', '.', ','];
  private isComaLast: boolean = false;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if ((event.key == '.' || event.key == ',') && !this.el.nativeElement.value) {
      event.preventDefault();
      return;
    }

    if (this.specialKeys.indexOf(event.key) !== -1) {
      if (event.key === ',') {
        this.isComaLast = true;
      }
      return;
    }
    let current = this.el.nativeElement.value;

    if (this.isComaLast) {
      current += '.';
      this.isComaLast = false;
    }

    if (Number(current + event.key) >= 100000) {
      event.preventDefault();
      return;
    }

    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key === 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
